import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { AddOnCustomize } from "./component";
import {
  selectedCfarIdSelector,
  fetchCfarQuotesCallStateSelector,
} from "../../../../ancillary/reducer";
import {
  isCfarAvailableInChosenRoomProductSelector,
  hotelCfarQuoteFromChosenRoomProductSelector,
  cancellationPolicyFromChosenRoomProductV2Selector,
  additionalInfoFromChosenRoomProductSelector,
  isOptionSelectionCompleteSelector,
  getHotelShopChosenProduct,
  getRefundableRoomProductCorrespondingToChosenRoom,
  getHotelShopChosenProductCorporateTravel,
  selectStandaloneCfarQuoteFromChosenRoomProduct,
} from "../../../../shop/reducer";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../../rewards/reducer";
import { IStoreState } from "../../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => ({
  isCfarAvailable: isCfarAvailableInChosenRoomProductSelector(state),
  selectedCfarId: selectedCfarIdSelector(state),
  cfarQuote: hotelCfarQuoteFromChosenRoomProductSelector(state),
  cfarQuoteV2: selectStandaloneCfarQuoteFromChosenRoomProduct(state),
  cancellationPolicy: cancellationPolicyFromChosenRoomProductV2Selector(state),
  additionalInfo: additionalInfoFromChosenRoomProductSelector(state),
  isOptionSelectionComplete: isOptionSelectionCompleteSelector(state),
  fetchCfarQuotesCallState: fetchCfarQuotesCallStateSelector(state),
  rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
  hotelShopChosenProduct: getHotelShopChosenProduct(state),
  refundableRoomProductCorrespondingToChosenRoom:
    getRefundableRoomProductCorrespondingToChosenRoom(state),
  corporateTravel: getHotelShopChosenProductCorporateTravel(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AddOnCustomizeConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedAddOnCustomize = withRouter(connector(AddOnCustomize));
